var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFieldDatatypeUrl = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 0h17a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m6.34 7.568c.692-.692 1.9-.692 2.592 0l.432.432.864-.864-.432-.432a3.03 3.03 0 0 0-2.16-.895c-.817 0-1.584.318-2.16.895L8.179 8a3.06 3.06 0 0 0 0 4.321c.572.574 1.35.895 2.16.894.81.001 1.588-.32 2.161-.894l.432-.432-.864-.864-.432.432a1.84 1.84 0 0 1-2.593 0 1.836 1.836 0 0 1 0-2.593zm2.16-3.89-.432.433.864.864.432-.432a1.84 1.84 0 0 1 2.593 0 1.836 1.836 0 0 1 0 2.593L14.66 8.432c-.692.692-1.9.692-2.592 0L11.636 8l-.864.864.432.432a3.03 3.03 0 0 0 2.16.895c.817 0 1.584-.318 2.16-.895L16.821 8a3.06 3.06 0 0 0 0-4.321 3.06 3.06 0 0 0-4.321 0z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFieldDatatypeUrl);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/field-datatype-url.b11d8bc0.svg";